import { title } from "process";

export const features = [
    {
        title: "Never Miss a Trend Again",
        description: "Get alerted to emerging product opportunities before they hit mainstream. Our AI monitors communities to spot trends weeks before your competitors catch on—giving you first-mover advantage.",
        iconPath: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
    },
    {
        title: "AI That Reads 10,000 Posts So You Don't Have To",
        description: "Stop drowning in Reddit threads. Our AI analyzes discussions and delivers crystal-clear insights about what users actually want. Get the essence of months of research in minutes.",
        iconPath: "M13 10V3L4 14h7v7l9-11h-7z"
    },
    {
        title: "Turn Reddit Conversations Into Revenue",
        description: "Every complaint is a product opportunity. Every feature request is market validation. Transform real user discussions into data-backed product decisions that actually make money.",
        iconPath: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
    },
    {
        title: "Know What Users Say Behind Your Back",
        description: "Monitor real conversations about your products and competitors. Discover why users love or hate features, what they're begging for, and how to position yourself to win their loyalty.",
        iconPath: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
    },
    {
        title: "Discover Your Next Customer Base",
        description: "Find untapped audiences discussing your industry. Identify new market segments, understand their unique needs, and create products specifically for communities your competitors don't even know exist.",
        iconPath: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
    },
    {
        title: "Build What Users Actually Want",
        description: "Stop building features nobody uses. Get direct insight into user problems, priorities, and pain points. Create products with guaranteed demand because you're solving real, validated problems.",
        iconPath: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
    }
];